import { render, staticRenderFns } from "./gradeStatis.vue?vue&type=template&id=378f8080&scoped=true"
import script from "./gradeStatis.vue?vue&type=script&lang=js"
export * from "./gradeStatis.vue?vue&type=script&lang=js"
import style0 from "./gradeStatis.vue?vue&type=style&index=0&id=378f8080&prod&lang=scss&scoped=true"
import style1 from "./gradeStatis.vue?vue&type=style&index=1&id=378f8080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378f8080",
  null
  
)

export default component.exports